import { faSearch } from '@fortawesome/pro-solid-svg-icons';
import Flex from 'components/ui/Flex';
import Input from 'components/ui/Input';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';

type SearchInputProps = {
    onSearch?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    inputRef: React.RefObject<HTMLInputElement>;
    containerRef: React.RefObject<HTMLDivElement>;
    onPaste?: (e: React.ClipboardEvent<HTMLInputElement>) => void;
    onKeyPress?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
    onClear?: () => void;
    onIconClick?: () => void;
    placeholder?: string;
    className?: string;
    searchString: string;
    height?: number;
};

const SearchInput = ({
    onSearch,
    inputRef,
    containerRef,
    onPaste,
    onKeyPress,
    onClear,
    onIconClick,
    placeholder,
    className,
    searchString,
    height,
}: SearchInputProps) => {
    const { t } = useTranslation();

    return (
        <InputWrapper $grow={1} ref={containerRef} column className={className} height={height}>
            <Input
                data-allow-paste
                className="search-input w-100"
                placeholder={placeholder ?? t('search')}
                autoFocus
                ref={inputRef}
                onChange={onSearch}
                name="Search"
                icon={faSearch}
                rightSidedIcon
                rounded
                onPaste={onPaste}
                onKeyDown={onKeyPress}
                onDeleteClick={onClear}
                searchString={searchString}
                onIconClick={() => {
                    if (onIconClick) {
                        onIconClick();
                    }
                }}
            />
        </InputWrapper>
    );
};

export default SearchInput;

const InputWrapper = styled(Flex)<{ height?: number }>`
    input {
        height: ${({ height }) => (height ? `${height}rem` : '3rem')};
    }
`;
